import React, { useState, useEffect, useContext } from 'react'
import { requestGetMontoFecha, requestAceptarTerminos } from '../utils/requests'
//import PropTypes from 'prop-types';
import { StepContext } from '../StepContext'
import { Col, Row } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'

Terminos.propTypes = {}

function Terminos(props) {
  const { setPuedeAvanzar, setCallback } = useContext(StepContext)
  const [monto, setMonto] = useState('')
  const [fecha, setFecha] = useState('')
  const [showTermino2, setShowTermino2] = useState(false)
  const [aceptoTerminos, setAceptoTerminos] = useState(false)
  const [termino1, setTermino1] = useState(false)
  const [termino2, setTermino2] = useState(false)

  useEffect(() => {
    getMontoFecha()
    setCallback(aceptarTerminos)
  }, [setCallback])

  useEffect(() => {
    setPuedeAvanzar(showTermino2 ? termino1 && termino2 : termino1)
  }, [termino1, termino2, setPuedeAvanzar, showTermino2])

  const aceptarTerminos = () => {
    return requestAceptarTerminos().then(({ status, content }) => {
      if (status === 200) {
        return true
      }
      return content
    })
  }

  const getMontoFecha = () => {
    requestGetMontoFecha().then(({ status, content }) => {
      if (status === 200) {
        setMonto(content.monto)
        setFecha(content.fecha)
        setShowTermino2(content.showTermino2)
        setAceptoTerminos(content.aceptoTerminos)
        if (content.aceptoTerminos) {
          setTermino1(true)
          setTermino2(true)
        }
      }
    })
  }

  return (
    <>
      <Row>
        <div className="col-lg-12 order-md-2">
          <h6 className="text-muted text-normal text-uppercase">
            Pautas de Funcionamiento del Sistema
          </h6>
          <hr className="margin-bottom-1x" />
          <div className="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x">
            <span className="alert-close" data-dismiss="alert"></span>
            <i className="icon-bell"></i>&nbsp;&nbsp;
            <strong>Importante:</strong> Debe aceptar las pautas del sistema
            para poder avanzar.
          </div>
          <Form.Row>
            <Col>
              <Form.Group>
                <div className="custom-control custom-checkbox custom-control-inline">
                  <Form.Control
                    className="custom-control-input"
                    checked={termino1}
                    style={{ opacity: 0 }}
                    disabled={aceptoTerminos}
                    onChange={(e) => setTermino1(e.target.checked)}
                    type="checkbox"
                    id="ex-check-5"
                  />
                  <Form.Label
                    className="custom-control-label"
                    htmlFor="ex-check-5"
                  >
                    Los datos declarados en la presente Declaración Jurada
                    quedan sujetos a verificación y control por la Autoridad de
                    Aplicación. En caso de que falsee u omita algún dato, será
                    pasible de sanciones legalmente previstas.
                  </Form.Label>
                </div>
              </Form.Group>
            </Col>
            <Col>
              {showTermino2 && (
                <Form.Group>
                  <div className="custom-control custom-checkbox custom-control-inline">
                    <Form.Control
                      className="custom-control-input"
                      checked={termino2}
                      style={{ opacity: 0 }}
                      disabled={aceptoTerminos}
                      onChange={(e) => setTermino2(e.target.checked)}
                      type="checkbox"
                      id="ex-check-6"
                    />
                    <Form.Label
                      className="custom-control-label"
                      htmlFor="ex-check-6"
                    >
                      Según verificaciones realizadas mediante intercambio de
                      información fiscal con Administraciones Tributarias
                      nacionales, provinciales y municipales, la Base Imponible
                      para el pago del Impuesto sobre los Ingresos Brutos por
                      Usted declarada, asciende a la suma de ${monto} al día{' '}
                      {fecha}.{' '}
                    </Form.Label>
                  </div>
                </Form.Group>
              )}
            </Col>
          </Form.Row>
        </div>
      </Row>
    </>
  )
}

export default Terminos
